export const borderLeftData = [
    {
      text: "Use the class of",
      code: ".b-l-* ",
    },
    {
      text: "for left border.",
    },
  ];
  
  export const borderRightData = [
    {
      text: "Use the class of",
      code: ".b-r-* ",
    },
    {
      text: "for right border.",
    },
  ];
  
  export const borderTopData = [
    {
      text: "Use the class of",
      code: ".b-t-* ",
    },
    {
      text: "for top border.",
    },
  ];
  
  export const borderBottomData = [
    {
      text: "Use the class of",
      code: ".b-b-* ",
    },
    {
      text: "for bottom border.",
    },
  ];
  
  export const borderPrimaryData = [
    {
      text: "Use the class of",
      code: ".b-l-*, .border-3  ",
    },
    {
      text: "is used to increase the width of the border.",
    },
  ];
  
  export const borderWarningData = [
    {
      text: "Use the class of",
      code: ".b-t-*, .border-3 ",
    },
    {
      text: "is used to increase the width of the border.",
    },
  ];
  
  export const borderSecondaryData = [
    {
      text: "Use the class of",
      code: ".b-r-* ,.border-3",
    },
    {
      text: "is used to increase the width of the border.",
    },
  ];
  
  export const borderSecondaryDataList = [
    {
      title: "Lola Stanford",
      color: "danger",
      tag: "Issue",
    },
    {
      title: "Caitlin Coungeau",
      color: "primary",
      tag: "Social",
    },
    {
      title: "Graciela McClaran",
      color: "danger",
      tag: "Issue",
    },
  ];
  
  export const cardAbsoluteData = [
    {
      className: "bg-primary",
      src: "blog/img.png",
      title:"Absolute Card",
      span: "We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively.",
    },
    {
      className: "bg-tertiary",
      src: "blog/blog.jpg",
      title:"Color State",
      span: "When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors to select to stay on your website.Building trust, expressing value,to the next step all depend on a page's design.",
    },
  ];